export default __webpack_public_path__ + "static/media/salt-lake-city-temple-flowers.e944d7d1.gif";